import React from "react";
import Grid from "@material-ui/core/Grid";
import { ThemeType } from "@theme";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  horizontal?: boolean;
  children?: React.ReactNode;
};

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    [theme.breakpoints.up("md")]: {
      flexWrap: "wrap",
      maxHeight: "100%"
    }
  }
}));

/**
 * Display left label and the field together inside grid items
 */
export function FormTab({ children, horizontal }: Props) {
  const classes = useStyles({});
  return (
    <Grid
      container
      spacing={2}
      direction={horizontal ? "row" : "column"}
      className={classes.root}
    >
      {children}
    </Grid>
  );
}

FormTab.defaultProps = {};
